<template>
    <div id="auctionBidsList" class="auctionItem_otherBidders">
        <h4 class="text-center">
            {{ $t("home.auction_item_label_other_offer") }}
        </h4>
        <ul ref="bidsList">
            <li
                v-for="(o, index) in bids"
                :key="index"
                class="align-items-center justify-content-center"
            >
                <img
                    class="profileImage"
                    :src="
                        o.avatarUrl ??
                        o.user.avatarUrl ??
                        '/images/male-default.png'
                    "
                />
                <b>{{ o.username ?? o.user.username }}</b>
                <template v-if="o.amount">
                    <b>{{ o.amount.abbr() }}</b>
                    <img
                        class="diamond"
                        :src="
                            user.mtsCustomer
                                ? '/images/rubins.png'
                                : '/images/diamond.png'
                        "
                    />
                </template>
            </li>
        </ul>
    </div>
</template>
<script>
import Vue from "vue";
import api from "../../api";

const BidsList = Vue.component("bids-list", {
    props: {
        auction: {
            type: Object,
            required: true,
        },
        itemsPerPage: {
            type: Number,
            default: 20,
        },
    },

    data() {
        return {
            bids: [],
            currentPage: 1,
            hasMoreItems: true,
            isLoading: false,
        };
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },

        isMyLeading() {
            return (
                !!this.auction.leadingBidder &&
                this.auction.leadingBidder.id === this.user.id
            );
        },
    },

    methods: {
        async fetchBids(page = 1) {
            if (!this.auction.id) return;

            try {
                this.isLoading = true;

                // laod bidders list when LOWEST_UNIQUE is not finished (bidders - users)
                const response =
                    this.auction.type === "LOWEST_UNIQUE" &&
                    this.auction.status !== "FINISHED"
                        ? await api.auctionsBidders(
                              this.auction.id,
                              page,
                              this.itemsPerPage
                          )
                        : await api.auctionsBids(
                              this.auction.id,
                              page,
                              this.itemsPerPage
                          );

                let newBids =
                    page === 1 && this.auction.type === "STANDARD"
                        ? (response.data ?? []).slice(1)
                        : response.data ?? [];

                if (page === 1) {
                    this.bids = newBids;
                } else {
                    this.bids.push(newBids);
                }

                this.hasMoreItems =
                    (response.data ?? []).length === this.itemsPerPage;
                this.currentPage = page;
            } catch (error) {
                api.baseErrorHendler(err);
            } finally {
                this.isLoading = false;
            }
        },

        handleScroll() {
            const element = this.$refs.bidsList;
            const bottom =
                Math.abs(
                    element.scrollHeight -
                        (element.scrollTop + element.clientHeight)
                ) < 1;

            if (bottom && !this.isLoading && this.hasMoreItems) {
                this.loadMore();
            }
        },

        loadMore() {
            if (this.hasMoreItems) {
                this.fetchBids(this.currentPage + 1);
            }
        },
    },

    mounted() {
        this.fetchBids();
        if (this.$refs.bidsList) {
            this.$refs.bidsList.addEventListener("scroll", this.handleScroll);
        }
    },

    beforeDestroy() {
        if (this.$refs.bidsList) {
            this.$refs.bidsList.removeEventListener(
                "scroll",
                this.handleScroll
            );
        }
    },
});

export default BidsList;
</script>
